import { DocumentsTableColumnModel } from '../../../shared/components';
import { TableAlignEnum } from '../../../shared/components';
import { PoTabs } from '../../enums';
import { get } from 'lodash';
import { CompanyProfile } from '../../../administration/models/company-profile.model';

export function getConfigColumns(companyProfile?: CompanyProfile): DocumentsTableColumnModel[] {
  const columns: DocumentsTableColumnModel[] = [
    {
      name: '#',
      prop: 'acc 1',
      width: '40px'
    },
    {
      name: 'COLUMN.ORDER_NUMBER',
      prop: 'runpleId',
      cell: 'rid',
      sortable: true,
      width: '180px',
      customizable: true
    },
    {
      name: 'COLUMN.STATUS',
      prop: 'status',
      cell: 'status',
      sortable: true,
      width: '124px',
      customizable: true,
      alignment: TableAlignEnum.CENTER,
      showWithStatuses: [
        PoTabs.All,
      ],
    },
    {
      name: 'COLUMN.SUPPLIER',
      prop: 'vendor',
      sortProp: 'vendorName',
      cell: 'partner',
      sortable: true,
      width: '1fr',
      minWidth: '150px',
      customizable: true
    },
    {
      name: 'COLUMN.AMOUNT',
      prop: 'amountGross',
      cell: 'amount',
      sortable: true,
      width: '156px',
      alignment: TableAlignEnum.RIGHT,
      customizable: true
    },
    {
      name: 'COLUMN.ORDER_DATE',
      prop: 'issueDate',
      cell: 'date',
      sortable: true,
      width: '150px',
      customizable: true
    },
    {
      name: 'COLUMN.POSITIONS_QTY',
      prop: 'positionsQuantity',
      cell: 'positions',
      sortable: true,
      width: '128px',
      alignment: TableAlignEnum.RIGHT,
      customizable: true,
      hiddenByDefault: true
    },
    {
      name: 'COLUMN.DELIVERY_DATE',
      prop: 'deliveryDate',
      cell: 'date',
      sortable: true,
      width: '128px',
      customizable: true,
      hiddenByDefault: true,
      showWithStatuses: [
        PoTabs.Open,
        PoTabs.Template,
      ]
    },
    {
      name: 'FORM.EXTERNAL_NUMBER',
      prop: 'externalNumber',
      sortable: true,
      width: '160px',
      customizable: true,
      hiddenByDefault: true
    },
    {
      name: 'COLUMN.SALES_ORDER_NUMBER',
      prop: 'linkedDocumentRunpleId',
      sortable: true,
      width: '180px',
      customizable: true,
      hiddenByDefault: true
    },
    {
      name: 'COLUMN.EMPLOYEE',
      prop: 'managerName',
      sortable: true,
      width: '160px',
      customizable: true,
      hiddenByDefault: true
    },
    {
      name: 'COMMON.INTERNAL_REMARK',
      prop: 'remark',
      sortable: true,
      width: '200px',
      customizable: true,
      hiddenByDefault: true
    },
    {
      name: 'COLUMN.UPDATED',
      prop: 'updatedAt',
      cell: 'dateTime',
      sortable: true,
      width: '160px',
      customizable: true,
      hiddenByDefault: true
    },
    {
      name: null,
      prop: 'billing',
      cell: 'billing',
      width: '64px',
      sticky: 'right',
      showWithStatuses: [
        PoTabs.Open,
        PoTabs.Completed,
        PoTabs.Template,
        PoTabs.All,
      ],
    },
    {
      name: null,
      prop: 'delivery',
      cell: 'delivery',
      width: '64px',
      sticky: 'right',
      showWithStatuses: [
        PoTabs.Open,
        PoTabs.Completed,
        PoTabs.Template,
        PoTabs.All,
      ],
      showCondition: !!get(companyProfile, 'subscriptionManagement.subscriptionPermissions.STOCK_STATUS'),
    },
    {
      name: null,
      prop: null,
      cell: 'open',
      width: '64px',
      sticky: 'right',
    },
  ];

  return columns.filter(col => col.showCondition === undefined || col.showCondition);
}
